import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Avatar, Badge, Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Button, Card, CardBody, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerHeader, DrawerOverlay, Flex, FormControl, FormLabel, Heading, IconButton, Image, Input, Menu, MenuButton, MenuItem, MenuList, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, SimpleGrid, Skeleton, SkeletonText, Stack, Stat, StatLabel, StatNumber, Text, useColorMode, useColorModeValue, useToast, Spinner } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { useStateContext } from '../../../context/ContextProvider'
import axiosClient from '../../../axios-client'
import { MdAdd, MdDelete, MdOutlineHeadsetMic, MdInventory2, MdReceiptLong, MdVerifiedUser } from 'react-icons/md'
import { GrDeliver } from "react-icons/gr";
import { FaBoxOpen } from "react-icons/fa";
import { TbTruckDelivery } from 'react-icons/tb';
import { RiMoneyDollarCircleFill } from 'react-icons/ri';
import { BsCheckCircleFill, BsXCircleFill, BsClockFill, BsQuestionCircleFill } from 'react-icons/bs';
import { CiEdit, CiMenuKebab } from 'react-icons/ci'
import { FiEdit3 } from 'react-icons/fi'
import { TiShoppingCart } from "react-icons/ti";
import ReactSelect from 'react-select'
import { RiCoupon3Fill } from 'react-icons/ri'
import { LiaFileInvoiceSolid } from "react-icons/lia";
import { IoMdPricetags } from "react-icons/io";
import { BsCart4 } from "react-icons/bs";
import countriesData from '../../../assets/dataJson/countries.json';
import { handlePriceChange, formatPriceForBackend } from '../../../utils/priceFormatter';
import { AsyncPaginate } from 'react-select-async-paginate'; let isFirstLoad_Details_GestConfirmation = true;
function Details_GestConfirmation() {
    const location = useLocation()
    const navigate = useNavigate()
    const { t } = useTranslation();
    const { user, setToken, setUser, currentBusiness, setCount } = useStateContext();
    const toast = useToast()
    const circleBg = useColorModeValue('white', 'gray.700');
    const circleBorder = useColorModeValue('gray.200', 'gray.600');
    const circleColor = useColorModeValue('gray.400', 'gray.500');
    const activeTimelineColor = useColorModeValue('green.400', 'green.300');
    
    // UI Hooks for Cart Redesign
    const cardBorderColor = useColorModeValue('gray.200', 'gray.700');
    const cardPriceBorderColor = useColorModeValue('gray.100', 'gray.700');
    const addProductBtnBorderColor = useColorModeValue('gray.300', 'gray.600');
    const addProductBtnColor = useColorModeValue('gray.500', 'gray.400');
    const addProductBtnHoverBg = useColorModeValue('gray.50', 'gray.700');
    
    // UI Hooks for Modals
    const modalHeaderBorderColor = useColorModeValue('gray.100', 'gray.700');
    const formLabelColor = useColorModeValue('gray.700', 'gray.300');
    const modalBoxBg = useColorModeValue('gray.50', 'gray.800');
    const modalBoxBorderColor = useColorModeValue('gray.100', 'gray.700');

    const [statusConfirmation, setStatusConfirmation] = useState('')
    const [statusStock, setStatusStock] = useState('')
    const [statusDelivery, setStatusDelivery] = useState('')
    const [loading, setLoading] = useState(false)

    const [detailOrder, setDetailOrder] = useState()
    const [productsOrderData, setProductsOrderData] = useState([])


    const [dataCoupon, setDataCoupon] = useState([])
    const [couponSelected, setCouponSelected] = useState()

    const [dataInfoClient, setDataInfoClient] = useState([])
    const [pageInfoClient, setPageInfoClient] = useState(1)
    const [hasMoreInfoClient, setHasMoreInfoClient] = useState(true)
    const [loadingInfoClient, setLoadingInfoClient] = useState(false)

    const fetchOldOrders = async (page = 1, numTel) => {
        if (!user?.id) return;
        if (!hasMoreInfoClient && page > 1) return;
        setLoadingInfoClient(true);
        try {
            const res = await axiosClient.get(`/commandes/getdataOldOrdersClient/?id=${location.state.id}&clientPhone=${encodeURIComponent(numTel)}&client_id=${user?.id}&business=${currentBusiness?.id}&page=${page}`, { hideLoader: !isFirstLoad_Details_GestConfirmation });
            isFirstLoad_Details_GestConfirmation = false;

            if (res.data.error === 'Client is disabled.' && res.data.etat === false) {
                setUser({});
                setToken(null);
                localStorage.removeItem("tokenExpirationTime");
                localStorage.removeItem("refreshTimeAdmin");
                localStorage.removeItem("role");

                if (!toast.isActive('accountDisabled')) {
                    toast({
                        id: 'accountDisabled',
                        description: t("le compte est désactivé"),
                        status: 'warning',
                        variant: 'left-accent',
                        duration: 2000,
                        isClosable: true,
                        position: 'bottom-right'
                    });
                }
                return;
            }

            if (res.data.results) {
                if (page === 1) {
                    setDataInfoClient(res.data.results);
                } else {
                    setDataInfoClient(prev => [...prev, ...res.data.results]);
                }
                setHasMoreInfoClient(res.data.next !== null);
                setPageInfoClient(page);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoadingInfoClient(false);
        }
    };

    const fetchData = async () => {
        try {
            setLoading(true)

            // Independent requests parallelized
            const [orderRes, productsRes, couponsRes] = await Promise.all([
                axiosClient.get(`commandes/${location.state.id}/`),
                user?.id ? axiosClient.get(`/produitCommande/getProductsOrder/?commande=${location.state.id}&client_id=${user?.id}&userRole=${user?.role}`) : Promise.resolve({data: []}),
                user?.id ? axiosClient.get(`/coupons/get_All_Coupons_For_New_Order/?client=${user?.id}&business=${currentBusiness?.id}`) : Promise.resolve({data: []})
            ]);

            // Set Data
            setDetailOrder(orderRes.data)
            
            if (productsRes.data.error === 'Client is disabled.' && productsRes.data.etat === false) {
                setUser({});
                setToken(null);
                localStorage.removeItem("tokenExpirationTime");
                localStorage.removeItem("refreshTimeAdmin");
                localStorage.removeItem("role");

                // Vérifier si le toast n'est pas déjà affiché
                if (!toast.isActive('accountDisabled')) {
                    toast({
                        id: 'accountDisabled',
                        description: t("le compte est désactivé"),
                        status: 'warning',
                        variant: 'left-accent',
                        duration: 2000,
                        isClosable: true,
                        position: 'bottom-right'
                    });
                }
            }
            setProductsOrderData(productsRes.data)
            setDataCoupon(couponsRes.data)

            // Dependent request
            if (orderRes.data && orderRes.data.tel) {
                await fetchOldOrders(1, orderRes.data.tel);
            }
            
        } catch (error) {
            console.error('ERROR fetching order details : ', error);
        } finally {
            setLoading(false)
        }
    }
    useEffect(() => {
        if (user) {
            fetchData()
        }
    }, [user])

    // Manual shipping send
    const [loadingShipping, setLoadingShipping] = useState(false)
    const sendToShippingCompany = async () => {
        try {
            setLoadingShipping(true)
            await axiosClient.post(`commandes/${location.state.id}/send_to_shipping/`)
                .then(res => {
                    // console.log('RESPONSE SHIPPING: ', res);
                    if (res.data.success) {
                        // Refresh notification count so the bell updates immediately
                        setCount(prev => (parseInt(prev) || 0) + 1)
                        toast({
                            description: res.data.message || t("Envoyé avec succès"),
                            status: 'success',
                            duration: 3000,
                            isClosable: true,
                            variant: 'left-accent',
                            position: 'bottom-right'
                        })
                    } else {
                        console.log('ERROR SHIPPING: 1 ', res.data.message);
                        let errorMsg = res.data.message || t("Échec de l'envoi");
                        if (res.data.details && res.data.details.length > 0) {
                            const detailsErrors = res.data.details
                                .map(d => `${d.company}: ${d.result.message}`)
                                .join(', ');
                            errorMsg = `${errorMsg} (${detailsErrors})`;
                        }
                        toast({
                            description: errorMsg,
                            status: 'error',
                            duration: 5000,
                            isClosable: true,
                            variant: 'left-accent',
                            position: 'bottom-right'
                        })
                    }
                })
        } catch (error) {
            console.log('ERROR SHIPPING: 2 ', error);
            toast({
                description: t("Erreur lors de l'envoi"),
                status: 'error',
                duration: 3000,
                isClosable: true,
                variant: 'left-accent',
                position: 'bottom-right'
            })
        } finally {
            setLoadingShipping(false)
        }
    }

    // Update status confirmation

    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const cancelRef = React.useRef()
    const [statusId, setStatusId] = useState()

    const onOpenAlert = (id) => {
        setIsAlertOpen(true);
        setStatusId(id)
    };
    const onCloseAlert = () => {
        setIsAlertOpen(false);
        setStatusConfirmation('')
        setStatusId()
    };


    const [isUpdatingStatusConf, setIsUpdatingStatusConf] = useState(false);
    const HandleChangeStatus = async () => {
        if (isUpdatingStatusConf) return;
        setIsUpdatingStatusConf(true);
        try {
            await axiosClient.patch(`commandes/${location.state.id}/`, {
                status_confirmation: statusConfirmation
            }).then((res) => {
                setDetailOrder(prevData => {
                    return {
                        ...prevData,
                        status_confirmation: res.data.status_confirmation

                    }
                })
                // setDataOrder(dataOrder.map((item) => {
                //     if (item.id === res.data.id) {
                //         return {
                //             ...item,
                //             status_confirmation: res.data.status_confirmation
                //         }
                //     }
                //     return item
                // }))
                onCloseAlert()
                toast({
                    description: t("Statut est changé avec succès"),
                    status: 'success',
                    duration: 2000,
                    isClosable: true,
                    variant: 'left-accent',
                    position: 'bottom-right'
                })
            })
        } catch (error) {
            // console.log('ERROR : ', error);
        } finally {
            setIsUpdatingStatusConf(false);
        }
    }


    // Update status stock

    const [isAlertOpenStatusStock, setIsAlertOpenStatusStock] = useState(false);
    const cancelRefStatusStock = React.useRef()

    const onOpenAlertStatusStock = () => {
        setIsAlertOpenStatusStock(true)
    }

    const onCloseAlertStatusStock = () => {
        setIsAlertOpenStatusStock(false);
        setStatusStock('')
    };

    const [isUpdatingStatusStock, setIsUpdatingStatusStock] = useState(false);
    const HandleChangeStatusStock = async () => {
        if (isUpdatingStatusStock) return;
        setIsUpdatingStatusStock(true);
        try {
            await axiosClient.patch(`commandes/${location.state.id}/`, {
                status_stock: statusStock === "Nouveau" ? null : statusStock
            }).then((res) => {
                setDetailOrder(prevData => {
                    return {
                        ...prevData,
                        status_stock: res.data.status_stock

                    }
                })
                // setDataOrder(dataOrder.map((item) => {
                //     if (item.id === res.data.id) {
                //         return {
                //             ...item,
                //             status_confirmation: res.data.status_confirmation
                //         }
                //     }
                //     return item
                // }))
                onCloseAlertStatusStock()
                toast({
                    description: t("Statut est changé avec succès"),
                    status: 'success',
                    duration: 2000,
                    isClosable: true,
                    variant: 'left-accent',
                    position: 'bottom-right'
                })
            })
        } catch (error) {
            // console.log('ERROR : ', error);
        } finally {
            setIsUpdatingStatusStock(false);
        }
    }


    // Update status delivery

    const [isAlertOpenStatusDelivery, setIsAlertOpenStatusDelivery] = useState(false);
    const cancelRefStatusDelivery = React.useRef()

    const onOpenAlertStatusDelivery = () => {
        setIsAlertOpenStatusDelivery(true)
    }

    const onCloseAlertStatusDelivery = () => {
        setIsAlertOpenStatusDelivery(false);
        setStatusDelivery('')
    };

    const [isUpdatingStatusDelivery, setIsUpdatingStatusDelivery] = useState(false);
    const HandleChangeStatusDelivery = async () => {
        if (isUpdatingStatusDelivery) return;
        setIsUpdatingStatusDelivery(true);
        try {
            await axiosClient.patch(`commandes/${location.state.id}/`, {
                status_delivery: statusDelivery === "Nouveau" ? null : statusDelivery
            }).then((res) => {
                setDetailOrder(prevData => {
                    return {
                        ...prevData,
                        status_delivery: res.data.status_delivery

                    }
                })
                // setDataOrder(dataOrder.map((item) => {
                //     if (item.id === res.data.id) {
                //         return {
                //             ...item,
                //             status_confirmation: res.data.status_confirmation
                //         }
                //     }
                //     return item
                // }))
                onCloseAlertStatusDelivery()
                toast({
                    description: t("Statut est changé avec succès"),
                    status: 'success',
                    duration: 2000,
                    isClosable: true,
                    variant: 'left-accent',
                    position: 'bottom-right'
                })
            })
        } catch (error) {
            // console.log('ERROR : ', error);
        } finally {
            setIsUpdatingStatusDelivery(false);
        }
    }


    // Update status facture

    const [isAlertOpenStatusFacture, setIsAlertOpenStatusFacture] = useState(false);
    const cancelRefStatusFacture = React.useRef()
    const [statusFacture, setStatusFacture] = useState('')

    const onOpenAlertStatusFacture = () => {
        setIsAlertOpenStatusFacture(true)
    }

    const onCloseAlertStatusFacture = () => {
        setIsAlertOpenStatusFacture(false);
        setStatusFacture('')
    };

    const [isUpdatingStatusFacture, setIsUpdatingStatusFacture] = useState(false);
    const HandleChangeStatusFacture = async () => {
        if (isUpdatingStatusFacture) return;
        setIsUpdatingStatusFacture(true);
        try {
            await axiosClient.patch(`commandes/${location.state.id}/`, {
                status_facture: statusFacture
            }).then((res) => {
                setDetailOrder(prevData => ({
                    ...prevData,
                    status_facture: res.data.status_facture
                }))
                onCloseAlertStatusFacture()
                toast({
                    description: t("Statut est changé avec succès"),
                    status: 'success',
                    duration: 2000,
                    isClosable: true,
                    variant: 'left-accent',
                    position: 'bottom-right'
                })
            })
        } catch (error) {
            // console.log('ERROR : ', error);
        } finally {
            setIsUpdatingStatusFacture(false);
        }
    }


    const [isAlertOpenCoupon, setIsAlertOpenCoupon] = useState(false);
    const cancelRefCoupon = React.useRef()

    const onOpenAlertCoupon = () => {
        setIsAlertOpenCoupon(true)
    }

    const onCloseAlertCoupon = () => {
        setIsAlertOpenCoupon(false);
        setCouponSelected()
    };

    const [isUpdatingCoupon, setIsUpdatingCoupon] = useState(false);
    const HandleChangeCoupon = async () => {
        if (isUpdatingCoupon) return;
        setIsUpdatingCoupon(true);
        const reduction = dataCoupon.find(e => e.id === parseInt(couponSelected)).reduction
        // console.log('Réduction : ', dataCoupon.find(e => e.id === parseInt(couponSelected)).reduction);
        try {
            await axiosClient.patch(`commandes/${location.state.id}/`, {
                coupon: couponSelected,
                priceWithCoupon: ((parseFloat(detailOrder?.price) - parseFloat(detailOrder?.price) * reduction / 100))
            }).then((res) => {
                setDetailOrder(prevData => {
                    return {
                        ...prevData,
                        coupon: res.data.coupon,
                        couponTitle: res.data.couponTitle,
                        priceWithCoupon: res.data.priceWithCoupon
                    }
                })
                // setDataOrder(dataOrder.map((item) => {
                //     if (item.id === res.data.id) {
                //         return {
                //             ...item,
                //             status_confirmation: res.data.status_confirmation
                //         }
                //     }
                //     return item
                // }))
                setCouponSelected()
                onCloseAlertCoupon()
                toast({
                    description: t("Coupon ajouté avec succès"),
                    status: 'success',
                    duration: 2000,
                    isClosable: true,
                    variant: 'left-accent',
                    position: 'bottom-right'
                })
            })
        } catch (error) {
            // console.log('ERROR : ', error);
        } finally {
            setIsUpdatingCoupon(false);
        }
    }

    const deleteCoupon = async () => {
        if (isUpdatingCoupon) return;
        setIsUpdatingCoupon(true);
        try {
            await axiosClient.patch(`commandes/${location.state.id}/`, {
                coupon: null,
                priceWithCoupon: null
            }).then((res) => {
                setDetailOrder(prevData => {
                    return {
                        ...prevData,
                        coupon: null,
                        couponTitle: null
                    }
                })
                // setDataOrder(dataOrder.map((item) => {
                //     if (item.id === res.data.id) {
                //         return {
                //             ...item,
                //             status_confirmation: res.data.status_confirmation
                //         }
                //     }
                //     return item
                // }))
                onCloseAlertCoupon()
                toast({
                    description: t("Coupon supprimé avec succès"),
                    status: 'success',
                    duration: 2000,
                    isClosable: true,
                    variant: 'left-accent',
                    position: 'bottom-right'
                })
            })
        } catch (error) {
            // console.log('ERROR : ', error);
        }
    }

    //Drawer

    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const drawerRef = React.useRef()

    const onOpenDrawer = () => {
        setIsDrawerOpen(true);
    };
    const onCloseDrawer = () => {
        setIsDrawerOpen(false);
    };



    // Modal Add Produt

    //Variables

    // Get Product 
    const [optionsTitre, setOptionsTitre] = useState([])
    const [productSelected, setProductSelected] = useState()

    const fetchProducts = async (userId, userRole) => {
        // Le fetching est maintenant géré dynamiquement par loadProductOptions
    }


    useEffect(() => {
        if (user?.id) {
            fetchProducts(user?.id, user?.role)
        }
    }, [user?.id])


    const [dataProducts, setDataProducts] = useState([])
    const [colorSelected, setColorSelected] = useState([])
    const [sizeSelected, setSizeSelected] = useState([])

    const loadProductOptions = async (search, loadedOptions, { page }) => {
        try {
            const res = await axiosClient.get(`/products/get_All_Products_names/?client=${user?.id}&page_size=20&page=${page}&search_term=${search}&userRole=${user?.role}&business=${currentBusiness?.id}`, { hideLoader: true });
            const results = res.data.results || [];
            const hasMore = res.data.next !== null && res.data.next !== undefined;

            return {
                options: results.map(product => ({
                    value: product.id,
                    label: product.title
                })),
                hasMore: hasMore,
                additional: {
                    page: page + 1,
                },
            };
        } catch (error) {
            // // console.error('Error fetching products', error);
            return { options: [], hasMore: false };
        }
    };
    const [imageProduct, setImageProduct] = useState()
    const [colorInput, setColorInput] = useState()
    const [sizeInput, setSizeInput] = useState()
    const [quantityInput, setQuantityInput] = useState()
    const [purchase_PriceInput, setPurchase_PriceInput] = useState()

    useEffect(() => {
        if (productSelected) {
            try {
                let colorOptions = []
                let sizeOptions = []
                axiosClient.get(`products/${productSelected.value}/?business=${currentBusiness?.id}`).then(res => {
                    setDataProducts(res.data)
                    setImageProduct(res.data?.images[0]?.image)
                    for (let index = 0; index < res.data.stock.length; index++) {
                        const color = res.data.stock[index].color;
                        const size = res.data.stock[index].size;

                        if (color && String(color).toLowerCase() !== 'null' && String(color).toLowerCase() !== 'none' && String(color).trim() !== '') {
                            colorOptions.push({
                                value: res.data.stock[index].id,
                                label: String(color).toLowerCase()
                            });
                        }

                        if (size && String(size).toLowerCase() !== 'null' && String(size).toLowerCase() !== 'none' && String(size).trim() !== '') {
                            sizeOptions.push({
                                value: res.data.stock[index].id,
                                label: String(size).toLowerCase()
                            });
                        }
                    }

                    // Supprimer les doublons pour les couleurs
                    colorOptions = Array.from(
                        new Map(colorOptions.map(item => [item.label.toLowerCase(), item])).values()
                    );

                    // Supprimer les doublons pour les tailles
                    sizeOptions = Array.from(
                        new Map(sizeOptions.map(item => [item.label.toLowerCase(), item])).values()
                    );
                    setColorSelected(colorOptions)
                    setSizeSelected(sizeOptions)
                })
            } catch (error) {
                // console.log('ERROR : ', error);
            }
        }
    }, [productSelected])

    const isNumericValid = (value) => {
        return /^\d+$/.test(value);
    };

    const isValidPrice = (value) => {
        return /^\d*\.?\d{0,2}$/.test(value.toString().replace(',', '.'));
    };


    const [isAddingProduct, setIsAddingProduct] = useState(false);
    const addProduct = async () => {
        if (isAddingProduct) return;
        setIsAddingProduct(true);
        try {

            // Validation des champs requis
            if (!productSelected || !quantityInput || !purchase_PriceInput) {
                toast({
                    description: t("Veuillez remplir tous les champs obligatoires"),
                    status: 'error',
                    variant: 'left-accent',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right'
                });
                return;
            }

            // Validation que quantité et prix sont des nombres
            if (!isNumericValid(quantityInput) || !isValidPrice(purchase_PriceInput)) {
                toast({
                    description: t("Le champ quantité doit contenir uniquement des chiffres et le prix un montant valide (ex: 10.22)"),
                    status: 'error',
                    variant: 'left-accent',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right'
                });
                return;
            }


            const payload = {
                product: productSelected.value,
                idCommande: location.state.id,
                color: colorInput ? colorInput.label : "",
                size: sizeInput ? sizeInput.label : "",
                quantity: parseInt(quantityInput),
                price: formatPriceForBackend(purchase_PriceInput)
            };

            await axiosClient.post(`produitCommande/createProduitCommande/`, payload).then(async (res) => {
                // console.log('RESPONSE: ', res.data);

                try {
                    const newPrice = (parseFloat(detailOrder?.price) + (formatPriceForBackend(purchase_PriceInput) * parseInt(quantityInput)))
                    await axiosClient.get(`commandes/${location.state.id}/`)
                        .then((res) => {
                            setDetailOrder(res.data)
                        })
                    toast({
                        description: t("Produit est ajouté avec succès"),
                        status: 'success',
                        duration: 2000,
                        isClosable: true,
                        variant: 'left-accent',
                        position: 'bottom-right'
                    })
                    setProductsOrderData(res.data)
                    onCloseModalAddProduct()
                } catch (error) {

                }

            })
                .catch((err) => {
                    // console.log('ERROR Catch ! ', err);
                })
        } catch (error) {
            // console.log('ERROR : ', error);
        } finally {
            setIsAddingProduct(false);
        }
    }


    const [isModalAddProductOpen, setIsModalAddProductOpen] = useState(false);
    const ModalAddProductRef = React.useRef()

    const onOpenModalAddProduct = () => {
        setIsModalAddProductOpen(true);
    };
    const onCloseModalAddProduct = () => {
        setIsModalAddProductOpen(false);
        setProductSelected()
        setDataProducts([])
        setColorInput()
        setSizeInput()
        setQuantityInput()
        setPurchase_PriceInput()
    };


    // Modal edit Product

    const [isModalEditProductOpen, setIsModalEditProductOpen] = useState(false);
    const ModalEditProductRef = React.useRef()
    const [idProduct, setIdProduct] = useState()
    const [totalAchat, setTotalAchat] = useState()
    const [oldQtt, setOldQtt] = useState()
    const [oldPurchase_PriceInput, setOldPurchase_PriceInput] = useState()
    const [loadingUpdateModal, setLoadingUpdateModal] = useState(false)

    const onOpenModalEditProduct = () => {
        setIsModalEditProductOpen(true);
    };
    const onCloseModalEditProduct = () => {
        setIsModalEditProductOpen(false);
        setProductSelected()
        setDataProducts([])
        setColorInput()
        setSizeInput()
        setQuantityInput()
        setPurchase_PriceInput()
        setIdProduct()
        setTotalAchat()
        setOldQtt()
        setOldPurchase_PriceInput()
    };

    const [getDataProduct_IdProduct, setGetDataProduct_IdProduct] = useState([])

    useEffect(() => {
        if (idProduct) {
            setLoadingUpdateModal(true)
            axiosClient.get(`produitCommande/${idProduct}/`).then(async (res) => {
                setGetDataProduct_IdProduct(res.data)

                setColorSelected(
                    Array.from(
                        new Map(
                            res.data.produit?.stock
                                .filter(e => e.color && String(e.color).toLowerCase() !== 'null' && String(e.color).toLowerCase() !== 'none' && String(e.color).trim() !== '')
                                .map(val => ({ value: val.id, label: String(val.color).toLowerCase() }))
                                .map(item => [item.label.toLowerCase(), item]) // Utilisé pour éliminer les doublons
                        ).values()
                    )
                );

                setSizeSelected(
                    Array.from(
                        new Map(
                            res.data.produit?.stock
                                .filter(e => e.size && String(e.size).toLowerCase() !== 'null' && String(e.size).toLowerCase() !== 'none' && String(e.size).trim() !== '')
                                .map(val => ({ value: val.id, label: String(val.size).toLowerCase() }))
                                .map(item => [item.label.toLowerCase(), item]) // Utilisé pour éliminer les doublons
                        ).values()
                    )
                );

                setLoadingUpdateModal(false)
            })
        }
    }, [idProduct])

    const [isUpdatingProduct, setIsUpdatingProduct] = useState(false);
    const EditProductOrder = async () => {
        if (isUpdatingProduct) return;
        setIsUpdatingProduct(true);
        try {

            // Validation que quantité et prix sont des nombres si remplis
            if ((quantityInput && !isNumericValid(quantityInput)) ||
                (purchase_PriceInput && !isValidPrice(purchase_PriceInput))) {
                toast({
                    description: t("Le champ quantité doit contenir uniquement des chiffres et le prix un montant valide (ex: 10.22)"),
                    status: 'error',
                    variant: 'left-accent',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right'
                });
                return;
            }


            const qte = quantityInput ? quantityInput : oldQtt
            const prix = purchase_PriceInput ? purchase_PriceInput : oldPurchase_PriceInput

            const payload = {
                idCommande: location.state.id,
            };

            if (colorInput) payload.color = colorInput.label || "";
            if (sizeInput) payload.size = sizeInput.label || "";
            if (quantityInput) payload.quantity = parseInt(quantityInput);
            if (purchase_PriceInput) payload.price = formatPriceForBackend(purchase_PriceInput);

            await axiosClient.patch(`produitCommande/updateProduitCommande/?idProductCommande=${idProduct}`, payload).then(async (res) => {

                await axiosClient.get(`commandes/${location.state.id}/`).then(async (response) => {
                    setDetailOrder(response.data)
                })

                setProductsOrderData(res.data)


                toast({
                    description: t("Produit est modifié avec succès"),
                    status: 'success',
                    duration: 2000,
                    isClosable: true,
                    variant: 'left-accent',
                    position: 'bottom-right'
                })

                onCloseModalEditProduct()

            })
                .catch((err) => {
                    // console.log('ERROR Catch ! ', err);
                })
        } catch (error) {
            // console.log('ERROR : ', error);
        } finally {
            setIsUpdatingProduct(false);
        }
    }


    // Delete Product
    const [deleteAlertOpen, setDeleteAlertOpen] = useState(false);
    const deleteAlertRef = React.useRef()
    const [deletedId, setDeletedId] = useState()

    const onOpenDeleteAlert = (id) => {
        setDeleteAlertOpen(true);
        setDeletedId(id)
    };
    const onCloseDeleteAlert = () => {
        setDeleteAlertOpen(false);
        setDeletedId()
    };


    const [isDeletingProduct, setIsDeletingProduct] = useState(false);
    const DeleteProduct = async () => {
        if (isDeletingProduct) return;
        setIsDeletingProduct(true);
        try {
            await axiosClient.delete(`produitCommande/deleteProduitCommande/?idProductCommande=${deletedId}`).then(async (response) => {
                await axiosClient.get(`commandes/${location.state.id}/`).then(async (res) => {
                    setDetailOrder(res.data)
                })
                setProductsOrderData(response.data)
                onCloseDeleteAlert()
                toast({
                    description: t("Produit est supprimé avec succès"),
                    status: 'success',
                    duration: 2000,
                    isClosable: true,
                    variant: 'left-accent',
                    position: 'bottom-right'
                })
            })
        } catch (error) {
            // console.log('ERROR : ', error);
        } finally {
            setIsDeletingProduct(false);
        }
    }

    // Modal edit client infos
    const [isModalClientInfosOpen, setIsModalClientInfosOpen] = useState(false);
    const ModalClientInfosRef = React.useRef()
    const [nomCompletClient, setNomCompletClient] = useState()
    const [emailClient, setEmailClient] = useState()
    const [paysClient, setPaysClient] = useState()
    const [codeCountryClient, setCodeCountryClient] = useState()
    const [villeClient, setVilleClient] = useState()
    const [codeCommande, setCodeCommande] = useState('')

    const countryOptions = countriesData.countries;
    const [adresseClient, setAdresseClient] = useState()
    const [phoneClient, setPhoneClient] = useState()
    const [phoneCode, setPhoneCode] = useState('+212')

    const onOpenModalClientInfos = () => {
        setIsModalClientInfosOpen(true);
        setCodeCommande(detailOrder?.code || '');
        setNomCompletClient(detailOrder?.full_name);
        setEmailClient(detailOrder?.email);
        setPaysClient(detailOrder?.pays);
        setCodeCountryClient(detailOrder?.code_country);
        setVilleClient(detailOrder?.ville);
        setAdresseClient(detailOrder?.address);

        let initialPhoneCode = '+212';
        if (detailOrder?.code_country) {
            const matchedCountry = countryOptions.find(c => c.value === detailOrder.code_country);
            if (matchedCountry && matchedCountry.phoneCode) {
                initialPhoneCode = matchedCountry.phoneCode;
            }
        }

        if (detailOrder?.tel) {
            let fullTel = detailOrder.tel.trim();
            const sortedCountries = [...countryOptions].sort((a, b) => (b.phoneCode || '').length - (a.phoneCode || '').length);
            const matchingCountry = sortedCountries.find(c => c.phoneCode && fullTel.replace(/\s+/g, '').startsWith(c.phoneCode));

            if (matchingCountry) {
                setPhoneCode(matchingCountry.phoneCode);
                let localPhone = fullTel.replace(/\s+/g, '').substring(matchingCountry.phoneCode.length);
                if (localPhone.startsWith('0')) {
                    localPhone = localPhone.substring(1);
                }
                setPhoneClient(localPhone);
            } else {
                setPhoneCode(initialPhoneCode);
                let localPhone = fullTel;
                if (localPhone.startsWith('0')) {
                    localPhone = localPhone.substring(1);
                }
                setPhoneClient(localPhone);
            }
        } else {
            setPhoneCode(initialPhoneCode);
            setPhoneClient('');
        }
    };
    const onCloseModalClientInfos = () => {
        setIsModalClientInfosOpen(false);
        setNomCompletClient()
        setEmailClient()
        setPaysClient()
        setCodeCountryClient()
        setVilleClient()
        setAdresseClient()
        setPhoneClient()
        setPhoneCode('+212')
        setCodeCommande('')
    };

    const [isUpdatingClientInfos, setIsUpdatingClientInfos] = useState(false);
    const editClientInfos = async () => {
        if (isUpdatingClientInfos) return;
        setIsUpdatingClientInfos(true);
        try {
            const formData = new FormData()
            nomCompletClient && formData.append('full_name', nomCompletClient)
            formData.append('code', codeCommande || '')
            emailClient && formData.append('email', emailClient)
            paysClient && formData.append('pays', paysClient)
            codeCountryClient && formData.append('code_country', codeCountryClient)
            villeClient && formData.append('ville', villeClient)
            adresseClient && formData.append('address', adresseClient)
            phoneClient && formData.append('tel', `${phoneCode ? phoneCode.replace(/\s+/g, '') : ''}${phoneClient ? phoneClient.replace(/\s+/g, '') : ''}`)
            await axiosClient.patch(`commandes/${location.state.id}/`, formData).then((res) => {
                setDetailOrder(prevData => {
                    return {
                        ...prevData,
                        full_name: res.data.full_name,
                        code: res.data.code,
                        email: res.data.email,
                        pays: res.data.pays,
                        code_country: res.data.code_country,
                        ville: res.data.ville,
                        address: res.data.address,
                        tel: res.data.tel
                    }
                })
                onCloseModalClientInfos()
                toast({
                    description: t("Informations du client sont modifiées avec succès"),
                    status: 'success',
                    duration: 2000,
                    isClosable: true,
                    variant: 'left-accent',
                    position: 'bottom-right'
                })
            })
                .catch((err) => {
                    console.log('ERROR Catch ! ', err);
                    let errMsg = t("Une erreur est survenue lors de la modification.");
                    if (err.response?.data) {
                        const data = err.response.data;
                        if (typeof data === 'string') {
                            errMsg = data;
                        } else if (data.message) {
                            errMsg = data.message;
                        } else if (data.error) {
                            errMsg = data.error;
                        } else {
                            const keys = Object.keys(data);
                            if (keys.length > 0) {
                                const val = data[keys[0]];
                                errMsg = Array.isArray(val) ? val[0] : String(val);
                            }
                        }
                    }
                    toast({
                        description: errMsg,
                        status: 'error',
                        variant: 'left-accent',
                        duration: 4000,
                        isClosable: true,
                        position: 'bottom-right'
                    });
                })
        } catch (error) {
            // console.log('ERROR : ', error);
        } finally {
            setIsUpdatingClientInfos(false);
        }
    }

    const btnMore = useColorModeValue('purple.400', 'purple.200')
    const hoverBtnMore = useColorModeValue('purple.600', 'purple.400')
    const menuItemDelete = useColorModeValue("red", "red.300")
    const bgAddProduct = useColorModeValue('gray.200', 'gray.600')
    const textAddProduct = useColorModeValue('gray.600', 'gray.200')
    const bgCard = useColorModeValue("gray", "gray.400")


    const colorbg = useColorModeValue('white', '#2d3748')

    const txtcolor = useColorModeValue('black', 'white')
    const colorbghover = useColorModeValue('#e2e8f0', '#171923')

    // ── Status pipeline colors (must be at top level, not inside callbacks) ──
    const pipelineBg = useColorModeValue('white', 'gray.700')
    const pipelineLabelColor = useColorModeValue('gray.500', 'gray.400')
    const pipelineConnectorBg = useColorModeValue('gray.200', 'gray.600')
    const pipelineIsDark = useColorModeValue(false, true)

    return (
        <Box position={"relative"} mb={5}>

            <Flex>
                <Box w="100%" display={"flex"} justifyContent="space-between" flexDirection={{ base: 'column', md: "row" }} mt={2} mb={{ base: 0, md: 5 }}>
                    <Breadcrumb fontStyle={"normal"} fontSize={{ base: "14px", sm: "14px", lg: "15px" }} color="gray.400" letterSpacing="-0.01em">
                        <BreadcrumbItem>
                            <BreadcrumbLink onClick={() => navigate('/')}>{t("Accueil")}</BreadcrumbLink>
                        </BreadcrumbItem>

                        <BreadcrumbItem isCurrentPage>
                            <BreadcrumbLink>{t("Détails commande")}</BreadcrumbLink>
                        </BreadcrumbItem>
                    </Breadcrumb>
                </Box>
            </Flex>

            <Box
                bg={useColorModeValue('white', 'gray.700')}
                p={5}
                rounded='xl'
                mx={5}
            >
                <Flex
                    flexDirection={{ base: 'column', md: 'row' }}
                    justifyContent='space-between'
                    alignItems='center'
                    gap={{ base: 5, md: 0 }}
                >
                    <Flex
                        flexDirection={{ base: 'column', md: 'row' }}
                        alignItems={'center'}
                        gap={4}
                    >
                        <Avatar h={70} w={70} rounded='xl'></Avatar>
                        <Flex flexDirection={"column"}>
                            <Flex alignItems='center' gap={2}>
                                <Text fontSize={15} fontWeight='semibold'>{detailOrder?.full_name}</Text>
                                {(t(`${detailOrder?.status_confirmation}`) !== t('Confirmé')) && (detailOrder?.status_stock === null || detailOrder?.status_stock === '') && (detailOrder?.status_delivery === null || detailOrder?.status_delivery === '') &&
                                    <CiEdit size={20} cursor="pointer" onClick={() => {
                                        if (detailOrder?.assigned_to === user?.id || ["AdminClient", "ManagerClient"].includes(user.role)) {
                                            onOpenModalClientInfos()
                                        }
                                    }} />
                                }
                            </Flex>
                            <Text fontSize={15}>{detailOrder?.tel}</Text>
                            <Text fontSize={13} color={useColorModeValue('gray.400', 'gray.500')}>{`${detailOrder?.pays}, ${detailOrder?.ville}, ${detailOrder?.address}`}</Text>
                            {detailOrder?.email !== 'undefined' && <Text fontSize={13} color={'lightgray'}>{detailOrder?.email}</Text>}
                        </Flex>
                    </Flex>


                    <Flex
                        flexDirection={{ base: 'column', lg: "row" }}
                        gap={3}
                        align='center'>


                        <Badge
                            colorScheme='purple'
                            rounded="xl" textAlign='center' minW={120} py={3} px={3} cursor={detailOrder?.status_confirmation !== 'Confirmé' && 'pointer'} textTransform='uppercase' onClick={() => {
                                {
                                    if (t(`${detailOrder?.status_confirmation}`) !== t('Confirmé') && ((detailOrder?.assigned_to === user?.id || ["AdminClient", "ManagerClient"].includes(user.role)))) {
                                        onOpenAlertCoupon()
                                    }
                                }
                            }}>
                            <Flex gap={2}>
                                <RiCoupon3Fill size={18} />
                                <Text textTransform='capitalize'>
                                    {detailOrder?.couponTitle ? detailOrder?.couponTitle : detailOrder?.status_confirmation !== 'Confirmé' ? t('Ajouter un coupon') : t('Pas de coupon')}
                                </Text>
                            </Flex>
                        </Badge>
                        {((detailOrder?.assigned_to === user?.id && user?.role !== "StockManagerClient") || ["AdminClient", "ManagerClient"].includes(user.role)) && (
                            <Button
                                size="md"
                                onClick={sendToShippingCompany}
                                isLoading={loadingShipping}
                                colorScheme="teal"
                                variant="solid"
                                py={5}
                                px={4}
                                rounded="xl"
                            >
                                {t("Envoyer au transporteur")}
                            </Button>
                        )}
                        <Button

                            _active={'none'}
                            colorScheme='green' variant='outline' w={120} py={3} h={"auto"} rounded='xl' fontSize={15} onClick={onOpenDrawer}>
                            {t("Plus")}
                        </Button>
                    </Flex>



                    {/* {(user.role === "StockManagerClient") && <Flex
                        flexDirection={{ base: 'column', lg: "row" }}
                        gap={3}
                        align='center'>
                        <Badge
                            colorScheme={
                                detailOrder?.status_stock !== 'Collecté'
                                    ? (['Épuisé', 'Annulé'].includes(detailOrder?.status_stock))
                                        ? 'red'
                                        : ([null, ''].includes(detailOrder?.status_stock))
                                            ? 'blue'
                                            : 'orange'
                                    : 'green'
                            }
                            rounded="xl" textAlign='center' minW={120} py={3} px={3} cursor='pointer' textTransform='uppercase' onClick={() => { onOpenAlertStatusStock() }}>
                            <Flex gap={2}>
                                <FaBoxOpen size={18} />
                                <Text>
                                    {detailOrder?.status_stock ? detailOrder?.status_stock : 'Nouveau'}
                                </Text>
                            </Flex>
                        </Badge>
                    </Flex>} */}
                </Flex>
            </Box>

            {/* ═══════════ Progression de la commande ═══════════ */}
            {(() => {
                // ── Cascade logic ────────────────────────────────────────────
                const confirmation = detailOrder?.status_confirmation || null;
                const stockRaw = detailOrder?.status_stock || null;
                const deliveryRaw = detailOrder?.status_delivery || null;
                const factureRaw = detailOrder?.status_facture || null;

                const stock = confirmation === 'Confirmé' ? (stockRaw || 'Nouveau') : stockRaw;
                const delivery = stock === 'Collecté' ? (deliveryRaw || 'Nouveau') : deliveryRaw;
                const facture = delivery === 'Livré' ? (factureRaw || 'Non payé') : null;

                const STATUS_META = {
                    // ── Confirmation ────────────────────────────────────────────
                    'Confirmé': { color: 'green', Icon: BsCheckCircleFill },
                    'Mauvais numéro': { color: 'red', Icon: MdOutlineHeadsetMic },
                    'Annulé': { color: 'red', Icon: BsXCircleFill },
                    'Pas de réponse': { color: 'orange', Icon: BsClockFill },
                    'Messagerie vocale': { color: 'orange', Icon: BsClockFill },
                    'En attente': { color: 'orange', Icon: BsClockFill },
                    'Ligne occupée': { color: 'orange', Icon: BsClockFill },
                    'Rappel': { color: 'blue', Icon: BsClockFill },
                    // ── Stock ─────────────────────────────────────────────────
                    'Nouveau': { color: 'blue', Icon: BsClockFill },
                    'Collecté': { color: 'teal', Icon: MdInventory2 },
                    'Épuisé': { color: 'orange', Icon: FaBoxOpen },
                    'Emballé': { color: 'cyan', Icon: MdInventory2 },
                    // ── Livraison ──────────────────────────────────────────────
                    'Livré': { color: 'green', Icon: TbTruckDelivery },
                    'Refusé': { color: 'red', Icon: BsXCircleFill },
                    'En cours': { color: 'blue', Icon: TbTruckDelivery },
                    'Ramassé': { color: 'blue', Icon: TbTruckDelivery },
                    'Expédié': { color: 'blue', Icon: TbTruckDelivery },
                    'Reçu à destination': { color: 'teal', Icon: TbTruckDelivery },
                    'Pendant la distribution': { color: 'blue', Icon: TbTruckDelivery },
                    'Programmé': { color: 'purple', Icon: BsClockFill },
                    'Hors zone': { color: 'orange', Icon: BsXCircleFill },
                    'Non atteint': { color: 'orange', Icon: BsXCircleFill },
                    'Préparation du retour': { color: 'orange', Icon: TbTruckDelivery },
                    "Retour à l'agence": { color: 'red', Icon: TbTruckDelivery },
                    "Retour à l'entrepôt": { color: 'red', Icon: TbTruckDelivery },
                    // ── Facture ────────────────────────────────────────────────
                    'Payé': { color: 'green', Icon: RiMoneyDollarCircleFill },
                    'Non payé': { color: 'orange', Icon: RiMoneyDollarCircleFill },
                };
                const getMeta = (v) => STATUS_META[v] || { color: 'gray', Icon: BsQuestionCircleFill };

                const isAdminOrManager = ['AdminClient', 'ManagerClient'].includes(user?.role);

                // ── "Locked by next" rule: can't edit a step if the next one already has a value
                //    (Admins/Managers are exempt from this restriction)
                const stockHasValue = !!(detailOrder?.status_stock && detailOrder.status_stock !== '');
                const deliveryHasValue = !!(detailOrder?.status_delivery && detailOrder.status_delivery !== '');
                const factureHasValue = !!(detailOrder?.status_facture && detailOrder.status_facture !== '');

                // ── Per-step config ────────────────────────────────────────────
                const steps = [
                    {
                        labelKey: 'Confirmation',
                        value: confirmation,
                        canEdit: isAdminOrManager || detailOrder?.assigned_to === user?.id,
                        lockedByNext: stockHasValue,
                        lockedByNextMsg: t('Stock déjà mis à jour, modification impossible'),
                        prereqMet: true,
                        prereqLabel: null,
                        onOpen: onOpenAlert,
                    },
                    {
                        labelKey: 'Stock',
                        value: stock,
                        canEdit: isAdminOrManager || detailOrder?.assigned_to_stock === user?.id,
                        lockedByNext: deliveryHasValue,
                        lockedByNextMsg: t('Livraison déjà mise à jour, modification impossible'),
                        prereqMet: confirmation === 'Confirmé',
                        prereqLabel: t('Confirmez d’abord la commande'),
                        onOpen: onOpenAlertStatusStock,
                    },
                    {
                        labelKey: 'Livraison',
                        value: delivery,
                        canEdit: isAdminOrManager || detailOrder?.assigned_to === user?.id,
                        lockedByNext: factureHasValue && detailOrder?.status_facture !== 'Non payé',
                        lockedByNextMsg: t('Facture déjà mise à jour, modification impossible'),
                        prereqMet: detailOrder?.status_stock === 'Collecté',
                        prereqLabel: t('Le stock doit être Collecté'),
                        onOpen: onOpenAlertStatusDelivery,
                    },
                    {
                        labelKey: 'Facture',
                        value: facture,
                        canEdit: isAdminOrManager || detailOrder?.assigned_to === user?.id,
                        lockedByNext: false,
                        lockedByNextMsg: null,
                        prereqMet: detailOrder?.status_delivery === 'Livré',
                        prereqLabel: t('La commande doit être Livrée'),
                        onOpen: onOpenAlertStatusFacture,
                    },
                ];

                // Pre-compute per-step styles (no hooks inside map)
                const stepStyles = steps.map(({ value }) => {
                    const meta = getMeta(value);
                    const c = meta.color || 'gray';
                    return {
                        colorScheme: c,
                        Icon: meta.Icon,
                        circleBg: pipelineIsDark ? `${c}.900` : `${c}.50`,
                        circleBorder: pipelineIsDark ? `${c}.300` : `${c}.400`,
                        circleColor: pipelineIsDark ? `${c}.300` : `${c}.600`,
                        connectorBg: value ? `${c}.300` : pipelineConnectorBg,
                    };
                });

                return (
                    <Box mt={5} bg={pipelineBg} p={5} rounded="xl" mx={5}>
                        <Text
                            fontSize="xs" fontWeight="800"
                            color={pipelineLabelColor}
                            textTransform="uppercase" letterSpacing="0.08em" mb={5}
                        >
                            {t("Progression de la commande")}
                        </Text>

                        <Box overflowX="auto" pb={2}>
                            <Flex
                                direction="row"
                                justify="space-between"
                                align="flex-start"
                                minW={{ base: "600px", md: "100%" }}
                                position="relative"
                            >
                            {steps.map(({ labelKey, value, canEdit, lockedByNext, lockedByNextMsg, prereqMet, prereqLabel, onOpen }, idx) => {
                                const { colorScheme, Icon: StatusIcon, circleBg, circleBorder, circleColor, connectorBg } = stepStyles[idx];
                                const isLast = idx === steps.length - 1;
                                // Step is fully editable only if prereq is met AND not locked by next
                                const isClickable = canEdit && prereqMet && !lockedByNext;
                                const isLocked = !prereqMet;
                                const isBlockedMsg = prereqMet && lockedByNext ? lockedByNextMsg : prereqLabel;

                                return (
                                    <Flex key={labelKey} flex="1" direction="column" align="center" position="relative">
                                        {/* connector line */}
                                        {!isLast && (
                                            <Box
                                                display="block"
                                                position="absolute"
                                                top="28px"
                                                right="-50%"
                                                width="100%"
                                                height="2px"
                                                bg={connectorBg}
                                                zIndex={0}
                                            />
                                        )}

                                        {/* icon circle — clickable if allowed */}
                                        <Flex
                                            w={14} h={14}
                                            rounded="full"
                                            bg={circleBg}
                                            border="3px solid"
                                            borderColor={isLocked ? pipelineConnectorBg : circleBorder}
                                            align="center"
                                            justify="center"
                                            color={isLocked ? pipelineLabelColor : circleColor}
                                            mb={3}
                                            zIndex={1}
                                            shadow="md"
                                            cursor={isClickable ? 'pointer' : (isLocked || lockedByNext) ? 'not-allowed' : 'default'}
                                            opacity={isLocked ? 0.45 : 1}
                                            transition="all 0.2s"
                                            _hover={isClickable ? { transform: 'scale(1.1)', shadow: 'lg' } : {}}
                                            onClick={() => {
                                                if (!prereqMet || lockedByNext) {
                                                    toast({
                                                        description: isBlockedMsg,
                                                        status: lockedByNext ? 'error' : 'warning',
                                                        duration: 2500,
                                                        isClosable: true,
                                                        variant: 'left-accent',
                                                        position: 'bottom-right'
                                                    });
                                                    return;
                                                }
                                                if (canEdit) onOpen();
                                            }}
                                        >
                                            <StatusIcon size={24} />
                                        </Flex>

                                        {/* label */}
                                        <Text
                                            fontSize="11px" fontWeight="700"
                                            color={pipelineLabelColor}
                                            textTransform="uppercase" letterSpacing="0.05em" mb={1}
                                        >
                                            {t(labelKey)}
                                        </Text>

                                        {/* badge */}
                                        <Badge
                                            colorScheme={value ? colorScheme : 'gray'}
                                            rounded="full"
                                            px={3} py={1}
                                            fontSize="11px"
                                            fontWeight="700"
                                            textAlign="center"
                                            cursor={isClickable ? 'pointer' : 'default'}
                                            onClick={() => {
                                                if (!prereqMet || lockedByNext) return;
                                                if (canEdit) onOpen();
                                            }}
                                        >
                                            {value ? t(value) : '—'}
                                        </Badge>

                                        {/* hint message */}
                                        {(isLocked || lockedByNext) && (
                                            <Text
                                                fontSize="9px"
                                                color={lockedByNext ? 'red.400' : 'orange.400'}
                                                mt={1} textAlign="center"
                                            >
                                                {isBlockedMsg}
                                            </Text>
                                        )}
                                    </Flex>
                                );
                            })}
                            </Flex>
                        </Box>
                    </Box>
                );
            })()}
            {/* ═══════════════════════════════════════════════════ */}

            <Box
                mt={10}
                bg={useColorModeValue('white', 'gray.700')}
                p={5}
                rounded='xl'
                mx={5}
            >
                <Flex justifyContent='space-between'>
                    <Flex alignItems='start'>
                        <Flex align="center" gap={1}>
                            <TiShoppingCart color={useColorModeValue('#a0aec0', '#a0aec0')} size={20} />
                            <Text fontSize={22} fontWeight='semibold'>
                                {t('Panier')}
                            </Text>
                        </Flex>
                    </Flex>
                </Flex>


                <Stack px={{ base: 2, md: 10 }} mb={5} mt={4} spacing={4}>
                    {productsOrderData.map((val, key) => {
                        return (
                            <Card key={key} rounded="2xl" shadow="sm" _hover={{ shadow: 'md' }} transition="all 0.2s" borderWidth={1} borderColor={cardBorderColor} overflow="hidden">
                                <CardBody p={0}>
                                    <Flex direction={{ base: 'column', md: 'row' }} align="center" justify="space-between">
                                        
                                        {/* Left: Image & Info */}
                                        <Flex direction={{ base: 'column', sm: 'row' }} align="center" gap={4} w="full">
                                            <Box w={{ base: "full", sm: "120px" }} h="120px" flexShrink={0} overflow="hidden">
                                                <Image
                                                    src={val.produit?.images[0]?.image}
                                                    alt='Image'
                                                    w="full" h="full"
                                                    objectFit="cover"
                                                    transition="transform 0.3s"
                                                    _hover={{ transform: 'scale(1.05)' }}
                                                />
                                            </Box>
                                            
                                            <Box p={{ base: 4, sm: 0 }} flex="1">
                                                <Flex align="center" gap={2} mb={1}>
                                                    <Heading fontSize='lg' fontWeight='600'>
                                                        {val.produit?.title}
                                                    </Heading>
                                                    {val.produit?.code && (
                                                        <Badge colorScheme="blue" fontSize="2xs" rounded="full" px={2} py={0.5}>
                                                            {val.produit.code}
                                                        </Badge>
                                                    )}
                                                </Flex>
                                                
                                                <Flex gap={3} mt={2}>
                                                    {val.color && (
                                                        <Badge colorScheme="gray" variant="subtle" rounded="md" px={2} py={1} fontSize="xs">
                                                            <Text as="span" color="gray.500" mr={1}>{t('Couleur')}:</Text>
                                                            {val.color}
                                                        </Badge>
                                                    )}
                                                    {val.size && (
                                                        <Badge colorScheme="gray" variant="subtle" rounded="md" px={2} py={1} fontSize="xs">
                                                            <Text as="span" color="gray.500" mr={1}>{t('Taille')}:</Text>
                                                            {val.size}
                                                        </Badge>
                                                    )}
                                                </Flex>
                                            </Box>
                                        </Flex>

                                        {/* Right: Price & Actions */}
                                        <Flex direction={{ base: 'row', md: 'column' }} align={{ base: 'center', md: 'flex-end' }} justify="space-between" w={{ base: 'full', md: 'auto' }} p={{ base: 4, md: 4 }} borderTop={{ base: '1px solid', md: 'none' }} borderColor={cardPriceBorderColor} borderLeft={{ md: '1px solid' }} minW="160px" gap={4}>
                                            <Flex direction="column" align={{ base: 'flex-start', md: 'flex-end' }}>
                                                <Text color="gray.500" fontSize="sm">{t("Quantité")} : {val.quantity}</Text>
                                                <Text fontWeight="bold" fontSize="lg" color="green.500">
                                                    {val.price} {currentBusiness?.order_currency}
                                                </Text>
                                            </Flex>

                                            {/* Actions */}
                                            {(user.role !== "StockManagerClient" &&
                                                detailOrder?.status_confirmation !== 'Confirmé' && (detailOrder?.assigned_to === user?.id || ["AdminClient", "ManagerClient"].includes(user.role))
                                            ) && (
                                                <Flex gap={2}>
                                                    <IconButton
                                                        icon={<FiEdit3 />}
                                                        size="sm"
                                                        rounded="full"
                                                        colorScheme="blue"
                                                        variant="ghost"
                                                        onClick={() => {
                                                            onOpenModalEditProduct()
                                                            setIdProduct(val.id)
                                                            setTotalAchat(val.quantity * val.price)
                                                            setOldQtt(val.quantity)
                                                            setOldPurchase_PriceInput(val.price)
                                                        }}
                                                        aria-label="Modifier"
                                                    />
                                                    {productsOrderData.length > 1 && (
                                                        <IconButton
                                                            icon={<MdDelete />}
                                                            size="sm"
                                                            rounded="full"
                                                            colorScheme="red"
                                                            variant="ghost"
                                                            onClick={() => {
                                                                onOpenDeleteAlert(val.id)
                                                                setTotalAchat(val.quantity * val.price)
                                                                setOldQtt(val.quantity)
                                                            }}
                                                            aria-label="Supprimer"
                                                        />
                                                    )}
                                                </Flex>
                                            )}
                                        </Flex>

                                    </Flex>
                                </CardBody>
                            </Card>
                        )
                    })}

                    {(user.role !== "StockManagerClient" &&
                        detailOrder?.status_confirmation !== 'Confirmé' && (detailOrder?.assigned_to === user?.id || ["AdminClient", "ManagerClient"].includes(user.role))
                    ) && (
                        <Button
                            mt={2}
                            w="full"
                            h="60px"
                            variant="outline"
                            borderStyle="dashed"
                            borderWidth={2}
                            borderColor={addProductBtnBorderColor}
                            color={addProductBtnColor}
                            rounded="2xl"
                            _hover={{ bg: addProductBtnHoverBg, borderColor: 'blue.400', color: 'blue.500' }}
                            leftIcon={<MdAdd size={20} />}
                            onClick={onOpenModalAddProduct}
                        >
                            {t('Nouveau produit')}
                        </Button>
                    )}
                </Stack>

            </Box>

            <Box
                mt={10}
                // bg={useColorModeValue('white', 'gray.700')}
                // p={5}
                rounded='xl'
                mx={5}>
                <SimpleGrid columns={{ base: 1, md: 2, lg: 2, xl: 3 }} spacing={{ base: 5, lg: 8 }}>
                    <Stat
                        px={{ base: 2, md: 4 }}
                        py={'5'}
                        shadow={'xl'}
                        bg={useColorModeValue('white', 'gray.700')}
                        rounded={'lg'}>
                        <Flex justifyContent={'space-between'}>
                            <Box pl={{ base: 2, md: 4 }}>
                                <StatLabel fontWeight={'medium'} isTruncated>
                                    <Text color='gray'>{t('Produit')}</Text>
                                </StatLabel>
                                <StatNumber fontSize={'2xl'} fontWeight={'medium'} >
                                    <Text fontWeight='semibold'>{productsOrderData?.length} </Text>
                                </StatNumber>
                            </Box>
                            <Box
                                my={'auto'}
                                color={useColorModeValue('purple.500', 'purple.300')}
                                alignContent={'center'}>
                                {<FaBoxOpen size={'3em'} />}
                            </Box>
                        </Flex>
                    </Stat>
                    <Stat
                        px={{ base: 2, md: 4 }}
                        py={'5'}
                        shadow={'xl'}
                        bg={useColorModeValue('white', 'gray.700')}
                        rounded={'lg'}>
                        <Flex justifyContent={'space-between'}>
                            <Box pl={{ base: 2, md: 4 }}>
                                <StatLabel fontWeight={'medium'} isTruncated>
                                    <Text color='gray'>{t('Quantité')}</Text>
                                </StatLabel>
                                <StatNumber fontSize={'2xl'} fontWeight={'medium'}>
                                    <Text fontWeight='semibold'>{detailOrder?.quantity_total}</Text>
                                </StatNumber>
                            </Box>
                            <Box
                                my={'auto'}
                                color={useColorModeValue('blue.500', 'blue.300')}
                                alignContent={'center'}>
                                {<BsCart4 size={'3em'} />}
                            </Box>
                        </Flex>
                    </Stat>
                    <Stat
                        px={{ base: 2, md: 4 }}
                        py={'5'}
                        shadow={'xl'}
                        bg={useColorModeValue('white', 'gray.700')}
                        rounded={'lg'}>
                        <Flex justifyContent={'space-between'}>
                            <Box pl={{ base: 2, md: 4 }}>
                                <StatLabel fontWeight={'medium'} isTruncated>
                                    <Text color='gray'>{t('Total prix')}</Text>
                                </StatLabel>
                                <StatNumber fontSize={'2xl'} fontWeight={'medium'}>
                                    <Flex gap={1}>
                                        <Flex alignItems="center" gap={1}>
                                            <Text color={detailOrder?.coupon && 'gray.400'} fontSize={detailOrder?.coupon && 15} fontWeight='semibold' textDecoration={detailOrder?.coupon && 'line-through'}>{detailOrder?.price}</Text>
                                            <Text h={"100%"} fontSize={12} >{currentBusiness?.order_currency}</Text>
                                        </Flex>
                                        {detailOrder?.coupon &&
                                            <>
                                                /
                                                <Flex alignItems="center" gap={1}>
                                                    <Text fontWeight='semibold'>{detailOrder?.priceWithCoupon}</Text>
                                                    <Text h={"100%"} fontSize={12} >{currentBusiness?.order_currency}</Text>
                                                </Flex>
                                            </>
                                        }
                                    </Flex>
                                </StatNumber>
                            </Box>
                            <Box
                                my={'auto'}
                                color={useColorModeValue('green.500', 'green.300')}
                                alignContent={'center'}>
                                {<IoMdPricetags size={'3em'} />}
                            </Box>
                        </Flex>
                    </Stat>
                    {/* <StatsCard title={'Servers'} stat={'1,000'} icon={<FiServer size={'3em'} />} />
                    <StatsCard title={'Datacenters'} stat={'7'} icon={<GoLocation size={'3em'} />} /> */}
                </SimpleGrid>
            </Box>


            {/* Alert to Update confirmation status */}

            <AlertDialog
                isOpen={isAlertOpen}
                leastDestructiveRef={cancelRef}
                onClose={onCloseAlert}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t('Statut de confirmation')}
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            <Text>
                                {t("Ici, vous pouvez modifier le statut de confirmation.")}
                            </Text>

                            <Select
                                mt={3}
                                rounded='lg'
                                size={"sm"}
                                value={statusConfirmation}
                                onChange={e => setStatusConfirmation(e.target.value)}
                            >
                                <option value="">{t('Statut de confirmation')}</option>
                                <option value='Nouveau'>{t('Nouveau')}</option>
                                <option value='Pas de réponse'>{t('Pas de réponse')}</option>
                                <option value='Messagerie vocale'>{t('Messagerie vocale')}</option>
                                <option value='En attente'>{t('En attente')}</option>
                                <option value='Ligne occupée'>{t('Ligne occupée')}</option>
                                <option value='Mauvais numéro'>{t('Mauvais numéro')}</option>
                                <option value='Annulé'>{t('Annulé')}</option>
                                <option value='Confirmé'>{t('Confirmé')}</option>
                            </Select>
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button colorScheme='yellow' size="sm" variant='outline' isLoading={isUpdatingStatusConf} isDisabled={statusConfirmation === null || isUpdatingStatusConf} mr={3} onClick={HandleChangeStatus}>
                                {t("Modifier")}
                            </Button>
                            <Button onClick={onCloseAlert} size="sm" >{t("Annuler")}</Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>


            {/* Alert to Update stock status */}

            <AlertDialog
                isOpen={isAlertOpenStatusStock}
                leastDestructiveRef={cancelRefStatusStock}
                onClose={onCloseAlertStatusStock}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t('Statut de stock')}
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            <Text>
                                {t("Ici, vous pouvez modifier le statut de stock.")}
                            </Text>

                            <Select
                                mt={3}
                                rounded='lg'
                                size={"sm"}
                                value={statusStock}
                                onChange={e => setStatusStock(e.target.value)}
                            >
                                <option value="">{t('Statut de stock')}</option>
                                <option value='Nouveau'>{t('Nouveau')}</option>
                                <option value='Épuisé'>{t('Épuisé')}</option>
                                <option value='Annulé'>{t('Annulé')}</option>
                                <option value='En cours'>{t('En cours')}</option>
                                <option value='Emballé'>{t('Emballé')}</option>
                                <option value='Collecté'>{t('Collecté')}</option>
                            </Select>
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button colorScheme='yellow' size="sm" variant='outline' isLoading={isUpdatingStatusStock} isDisabled={statusStock === null || isUpdatingStatusStock} mr={3} onClick={HandleChangeStatusStock}>
                                {t("Modifier")}
                            </Button>
                            <Button onClick={onCloseAlertStatusStock} size="sm" >{t("Annuler")}</Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>


            {/* Alert to Update stock delivery */}

            <AlertDialog
                isOpen={isAlertOpenStatusDelivery}
                leastDestructiveRef={cancelRefStatusDelivery}
                onClose={onCloseAlertStatusDelivery}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t('Statut de livraison')}
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            <Text>
                                {t("Ici, vous pouvez modifier le statut de livraison.")}
                            </Text>

                            <Select
                                mt={3}
                                rounded='lg'
                                size={"sm"}
                                value={statusDelivery}
                                onChange={e => setStatusDelivery(e.target.value)}
                            >
                                <option value="">{t('Statut de livraison')}</option>
                                <option value="Nouveau">{t('Nouveau')}</option>
                                <option value='Ramassé'>{t('Ramassé')}</option>
                                <option value='Expédié'>{t('Expédié')}</option>
                                <option value='Reçu à destination'>{t('Reçu à destination')}</option>
                                <option value='Pendant la distribution'>{t('Pendant la distribution')}</option>
                                <option value='Programmé'>{t('Programmé')}</option>
                                <option value='Hors zone'>{t('Hors zone')}</option>
                                <option value='Non atteint'>{t('Non atteint')}</option>
                                <option value='Annulé'>{t('Annulé')}</option>
                                <option value='Refusé'>{t('Refusé')}</option>
                                <option value='Livré'>{t('Livré')}</option>
                                <option value='Préparation du retour'>{t('Préparation du retour')}</option>
                                <option value="Retour à l'agence">{t("Retour à l'agence")}</option>
                                <option value="Retour à l'entrepôt">{t("Retour à l'entrepôt")}</option>
                            </Select>
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button colorScheme='yellow' size="sm" variant='outline' isLoading={isUpdatingStatusDelivery} isDisabled={statusDelivery === null || isUpdatingStatusDelivery} mr={3} onClick={HandleChangeStatusDelivery}>
                                {t("Modifier")}
                            </Button>
                            <Button onClick={onCloseAlertStatusDelivery} size="sm" >{t("Annuler")}</Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>


            {/* Alert to Add or Update Coupon */}

            <AlertDialog
                isOpen={isAlertOpenCoupon}
                leastDestructiveRef={cancelRefCoupon}
                onClose={onCloseAlertCoupon}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t('Coupon')}
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            <Text>
                                {t("Ici, vous pouvez ajouter, modifier ou supprimer le coupon.")}
                            </Text>

                            <Select
                                mt={3}
                                rounded='lg'
                                size={"sm"}
                                defaultValue={detailOrder?.coupon ? detailOrder?.coupon : couponSelected}
                                onChange={e => setCouponSelected(e.target.value)}
                            >
                                <option value=''>{t('Coupon')}</option>
                                {dataCoupon.map((val, key) => {
                                    return (
                                        <option key={key} value={val.id}>{val.code}</option>
                                    )
                                })}
                            </Select>
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Flex justifyContent="space-between" w="100%">
                                <Flex>
                                    <Button onClick={deleteCoupon} isLoading={isUpdatingCoupon} isDisabled={isUpdatingCoupon} size="sm" colorScheme='red' >{t("Supprimer")}</Button>
                                </Flex>
                                <Flex>
                                    <Button colorScheme='yellow' size="sm" variant='outline' isLoading={isUpdatingCoupon} isDisabled={!couponSelected || isUpdatingCoupon} mr={3} onClick={HandleChangeCoupon}>
                                        {t("Modifier")}
                                    </Button>
                                    <Button onClick={onCloseAlertCoupon} size="sm" >{t("Annuler")}</Button>
                                </Flex>
                            </Flex>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>


            {/* Drawer */}
            <Drawer size={{ sm: 'full', md: 'xl' }} placement={"right"} onClose={onCloseDrawer} isOpen={isDrawerOpen}>
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerCloseButton />
                    <DrawerHeader borderBottomWidth='1px'>{t("Informations client")}</DrawerHeader>
                    <DrawerBody onScroll={(e) => {
                        const bottom = Math.ceil(e.target.scrollHeight - e.target.scrollTop) >= e.target.clientHeight - 5;
                        if (bottom && hasMoreInfoClient && !loadingInfoClient) {
                            fetchOldOrders(pageInfoClient + 1, detailOrder?.tel || location.state.tel);
                        }
                    }}>
                        <Flex flexDirection="column" gap={6} py={4}>
                            {
                                dataInfoClient.length > 0 ?
                                    dataInfoClient.map((val, key) => {
                                        return (
                                            <Box key={key} p={4} borderWidth="1px" borderRadius="xl" shadow="sm">
                                                <Flex align="center" justify="space-between" mb={4}>
                                                    <Flex gap={1}>
                                                        <Text color="gray.500">{t("Commande :")}</Text>
                                                        <Text fontWeight={600}>{val.code}</Text>
                                                    </Flex>
                                                    <Text fontSize="sm" color="gray.400">
                                                        {new Date(val.date_creation).toLocaleDateString()}
                                                    </Text>
                                                </Flex>

                                                <Box overflowX="auto" pb={2}>
                                                    <Flex gap={0} w="max-content" align="flex-start">
                                                        {[
                                                            { label: 'Confirmation', value: val.status_confirmation || 'Nouveau', icon: <MdOutlineHeadsetMic size={18} />, isActive: val.status_confirmation && val.status_confirmation !== 'Nouveau' },
                                                            { label: 'Stock', value: val.status_stock || 'Nouveau', icon: <FaBoxOpen size={18} />, isActive: val.status_stock && val.status_stock !== 'Nouveau' },
                                                            { label: 'Livraison', value: val.status_delivery || 'Nouveau', icon: <GrDeliver size={18} />, isActive: val.status_delivery && val.status_delivery !== 'Nouveau' },
                                                            { label: 'Facture', value: val.status_facture || 'Non payé', icon: <LiaFileInvoiceSolid size={18} />, isActive: val.status_facture && val.status_facture !== 'Non payé' },
                                                        ].map((step, idx, arr) => (
                                                            <Flex key={idx} align="center">
                                                                <Flex direction="column" align="center" position="relative" w={28}>
                                                                    <Flex
                                                                        w={10} h={10}
                                                                        rounded="full"
                                                                        bg={circleBg}
                                                                        border="2px solid"
                                                                        borderColor={step.isActive ? activeTimelineColor : circleBorder}
                                                                        color={step.isActive ? activeTimelineColor : circleColor}
                                                                        align="center"
                                                                        justify="center"
                                                                        shadow="sm"
                                                                        zIndex={1}
                                                                    >
                                                                        {step.icon}
                                                                    </Flex>
                                                                    <Text fontSize="xs" fontWeight="bold" mt={2} color={step.isActive ? activeTimelineColor : circleColor} textAlign="center">
                                                                        {t(step.value)}
                                                                    </Text>
                                                                </Flex>
                                                                {idx < arr.length - 1 && (
                                                                    <Box w={12} h="2px" bg={step.isActive ? activeTimelineColor : circleBorder} mx={-4} mt={-6} zIndex={0} />
                                                                )}
                                                            </Flex>
                                                        ))}
                                                    </Flex>
                                                </Box>
                                            </Box>
                                        )
                                    })
                                    :
                                    <Flex justify="center" p={4}>
                                        <Text>{t("Aucune donnée n'a été trouvée.")}</Text>
                                    </Flex>
                            }
                        </Flex>
                    </DrawerBody>
                </DrawerContent>
            </Drawer>




            {/* Modal to add product in order */}
            <Modal size="lg" isCentered closeOnOverlayClick={ModalAddProductRef} isOpen={isModalAddProductOpen} onClose={onCloseModalAddProduct}>
                <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
                <ModalContent rounded="2xl" shadow="2xl">
                    <ModalHeader borderBottom="1px solid" borderColor={modalHeaderBorderColor} pb={4} mb={4}>
                        {t("Ajout d'un nouveau produit")}
                    </ModalHeader>
                    <ModalCloseButton mt={2} />
                    <ModalBody pb={6}>

                        <FormControl isRequired mb={5}>
                            <FormLabel fontWeight="600" color={formLabelColor}>
                                {t("Rechercher un produit")}
                            </FormLabel>
                            <AsyncPaginate
                                loadOptions={loadProductOptions}
                                additional={{ page: 1 }}
                                onChange={setProductSelected}
                                value={productSelected}
                                name='produit'
                                placeholder={t("Produit")}
                                isClearable={true}
                                noOptionsMessage={() => t("Aucun produit trouvé")}
                                styles={{

                                    control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        backgroundColor: 'transparent',
                                        borderColor: 'gray.200'

                                    }),
                                    menu: (provided) => ({
                                        ...provided,
                                        textAlign: 'left',
                                        backgroundColor: colorbg,
                                        cursor: "pointer",
                                        zIndex: 9999
                                    }),
                                    option: (provided, state) => ({
                                        backgroundColor: colorbg,

                                        ...provided,
                                        color: txtcolor,
                                        backgroundColor: state.isSelected ? colorbg : 'inherit',
                                        '&:hover': {
                                            backgroundColor: colorbghover,
                                        },

                                        cursor: "pointer"
                                    }),
                                    singleValue: (provided) => ({
                                        ...provided,
                                        color: txtcolor,
                                    }),

                                }}
                            />
                        </FormControl>

                        {dataProducts.length !== 0 && (
                            <Box bg={modalBoxBg} p={5} rounded="xl" borderWidth="1px" borderColor={modalBoxBorderColor}>
                                <Flex align="center" gap={5} mb={6}>
                                    <Avatar
                                        h="80px"
                                        w="80px"
                                        rounded="xl"
                                        shadow="sm"
                                        name='image'
                                        src={imageProduct} 
                                    />
                                    <Box>
                                        <Text fontWeight="600" fontSize="lg">{productSelected?.label}</Text>
                                        <Text fontSize="sm" color="gray.500">{t("Détails du produit sélectionné")}</Text>
                                    </Box>
                                </Flex>

                                <Stack spacing={5}>
                                    {(colorSelected.length !== 0 || sizeSelected.length !== 0) && (
                                        <Flex gap={4}>
                                            {colorSelected.length !== 0 && (
                                                <FormControl flex={1}>
                                                    <FormLabel fontSize="sm" color="gray.500" fontWeight="600">{t("Couleur")}</FormLabel>
                                                    <ReactSelect
                                                        onChange={setColorInput}
                                                        value={colorInput}
                                                        name='colorInput'
                                                        options={colorSelected}
                                                        placeholder={t("Couleur")}
                                                        isClearable
                                                        styles={{
                                                            control: (baseStyles, state) => ({
                                                                ...baseStyles,
                                                                backgroundColor: 'transparent',
                                                                borderColor: 'gray.200'
                                                            }),
                                                            menu: (provided) => ({
                                                                ...provided,
                                                                textAlign: 'left',
                                                                backgroundColor: colorbg,
                                                                cursor: "pointer"
                                                            }),
                                                            option: (provided, state) => ({
                                                                ...provided,
                                                                color: txtcolor,
                                                                backgroundColor: state.isSelected ? colorbg : 'inherit',
                                                                '&:hover': {
                                                                    backgroundColor: colorbghover,
                                                                },
                                                                cursor: "pointer"
                                                            }),
                                                            singleValue: (provided) => ({
                                                                ...provided,
                                                                color: txtcolor,
                                                            }),
                                                        }}
                                                    />
                                                </FormControl>
                                            )}

                                            {sizeSelected.length !== 0 && (
                                                <FormControl flex={1}>
                                                    <FormLabel fontSize="sm" color="gray.500" fontWeight="600">{t("Taille")}</FormLabel>
                                                    <ReactSelect
                                                        onChange={setSizeInput}
                                                        value={sizeInput}
                                                        name='SizeInput'
                                                        options={sizeSelected}
                                                        placeholder={t("Taille")}
                                                        isClearable
                                                        styles={{
                                                            control: (baseStyles, state) => ({
                                                                ...baseStyles,
                                                                backgroundColor: 'transparent',
                                                                borderColor: 'gray.200'
                                                            }),
                                                            menu: (provided) => ({
                                                                ...provided,
                                                                textAlign: 'left',
                                                                backgroundColor: colorbg,
                                                                cursor: "pointer"
                                                            }),
                                                            option: (provided, state) => ({
                                                                ...provided,
                                                                color: txtcolor,
                                                                backgroundColor: state.isSelected ? colorbg : 'inherit',
                                                                '&:hover': {
                                                                    backgroundColor: colorbghover,
                                                                },
                                                                cursor: "pointer"
                                                            }),
                                                            singleValue: (provided) => ({
                                                                ...provided,
                                                                color: txtcolor,
                                                            }),
                                                        }}
                                                    />
                                                </FormControl>
                                            )}
                                        </Flex>
                                    )}

                                    <Flex gap={4}>
                                        <FormControl isRequired flex={1}>
                                            <FormLabel fontSize="sm" color="gray.500" fontWeight="600">{t("Quantité")}</FormLabel>
                                            <Input
                                                type="number"
                                                min={1}
                                                variant="filled"
                                                focusBorderColor="blue.400"
                                                placeholder={t('Quantité')}
                                                defaultValue={quantityInput}
                                                onChange={e => setQuantityInput(e.target.value)}
                                            />
                                        </FormControl>

                                        <FormControl isRequired flex={1}>
                                            <FormLabel fontSize="sm" color="gray.500" fontWeight="600" display="flex" alignItems="center" gap={1}>
                                                <Text>{t("Prix d'achat")}</Text>
                                                <Badge colorScheme="green" rounded="sm" fontSize="2xs">{currentBusiness?.order_currency}</Badge>
                                            </FormLabel>
                                            <Input
                                                variant="filled"
                                                focusBorderColor="blue.400"
                                                placeholder={t("Prix d'achat")}
                                                value={purchase_PriceInput}
                                                onChange={e => {
                                                    const val = handlePriceChange(e.target.value);
                                                    if (val !== null) setPurchase_PriceInput(val);
                                                }}
                                            />
                                        </FormControl>
                                    </Flex>
                                </Stack>
                            </Box>
                        )}
                    </ModalBody>

                    <ModalFooter borderTop="1px solid" borderColor={modalHeaderBorderColor} pt={4} mt={2}>
                        <Button variant="ghost" onClick={onCloseModalAddProduct} mr={3} rounded="full">
                            {t("Annuler")}
                        </Button>
                        <Button colorScheme='blue' rounded="full" px={6} shadow="md" isLoading={isAddingProduct} isDisabled={isAddingProduct} onClick={addProduct}>
                            {t("Ajouter au panier")}
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>


            {/* Modal to edit product in order */}
            <Modal size="lg" isCentered closeOnOverlayClick={ModalEditProductRef} isOpen={isModalEditProductOpen} onClose={onCloseModalEditProduct}>
                <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
                <ModalContent rounded="2xl" shadow="2xl">
                    <ModalHeader borderBottom="1px solid" borderColor={modalHeaderBorderColor} pb={4} mb={4}>
                        {t("Modification du produit")}
                    </ModalHeader>
                    <ModalCloseButton mt={2} />
                    {!loadingUpdateModal &&
                        <ModalBody pb={6}>
                            <Box bg={modalBoxBg} p={5} rounded="xl" borderWidth="1px" borderColor={modalBoxBorderColor}>
                                <Flex align="center" gap={5} mb={6}>
                                    <Avatar
                                        h="80px"
                                        w="80px"
                                        rounded="xl"
                                        shadow="sm"
                                        name='image'
                                        src={getDataProduct_IdProduct.produit?.images[0]?.image} 
                                    />
                                    <Box>
                                        <Text fontWeight="600" fontSize="lg">{getDataProduct_IdProduct.produit?.title}</Text>
                                        {getDataProduct_IdProduct.produit?.code && (
                                            <Badge colorScheme="blue" fontSize="2xs" rounded="full" px={2} py={0.5} mt={1}>
                                                {t('Code')}: {getDataProduct_IdProduct.produit.code}
                                            </Badge>
                                        )}
                                    </Box>
                                </Flex>

                                <Stack spacing={5}>
                                    <Flex gap={4}>
                                {colorSelected?.length !== 0 &&
                                    <FormControl isRequired flex={1}>
                                        <FormLabel fontSize="sm" color="gray.500" fontWeight="600">{t("Couleur")}</FormLabel>
                                        <ReactSelect
                                            onChange={setColorInput}
                                            value={
                                                colorInput
                                                    ? colorInput
                                                    : {
                                                        value: colorSelected?.find(e => e.label === getDataProduct_IdProduct?.color)?.value,
                                                        label: getDataProduct_IdProduct?.color
                                                    }
                                            }
                                            name='colorInput'
                                            options={colorSelected}
                                            placeholder={t("Couleur")}
                                            styles={{
                                                control: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    backgroundColor: 'transparent',
                                                    borderColor: 'gray.200'
                                                }),
                                                menu: (provided) => ({
                                                    ...provided,
                                                    textAlign: 'left',
                                                    backgroundColor: colorbg,
                                                    cursor: "pointer"
                                                }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    color: txtcolor,
                                                    backgroundColor: state.isSelected ? colorbg : 'inherit',
                                                    '&:hover': {
                                                        backgroundColor: colorbghover,
                                                    },
                                                    cursor: "pointer"
                                                }),
                                                singleValue: (provided) => ({
                                                    ...provided,
                                                    color: txtcolor,
                                                }),
                                            }}
                                        />
                                    </FormControl>
                                }

                                {sizeSelected?.length !== 0 &&
                                    <FormControl isRequired flex={1}>
                                        <FormLabel fontSize="sm" color="gray.500" fontWeight="600">{t("Taille")}</FormLabel>
                                        <ReactSelect
                                            onChange={setSizeInput}
                                            value={
                                                sizeInput
                                                    ? sizeInput
                                                    : {
                                                        value: colorSelected?.find(e => e.label === getDataProduct_IdProduct?.size)?.value,
                                                        label: getDataProduct_IdProduct?.size
                                                    }
                                            }
                                            name='sizeInput'
                                            options={sizeSelected}
                                            placeholder={t("Taille")}
                                            styles={{
                                                control: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    backgroundColor: 'transparent',
                                                    borderColor: 'gray.200'
                                                }),
                                                menu: (provided) => ({
                                                    ...provided,
                                                    textAlign: 'left',
                                                    backgroundColor: colorbg,
                                                    cursor: "pointer"
                                                }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    color: txtcolor,
                                                    backgroundColor: state.isSelected ? colorbg : 'inherit',
                                                    '&:hover': {
                                                        backgroundColor: colorbghover,
                                                    },
                                                    cursor: "pointer"
                                                }),
                                                singleValue: (provided) => ({
                                                    ...provided,
                                                    color: txtcolor,
                                                }),
                                            }}
                                        />
                                    </FormControl>
                                }
                            </Flex>

                            <Flex gap={4}>
                                <FormControl isRequired flex={1}>
                                    <FormLabel fontSize="sm" color="gray.500" fontWeight="600">{t("Quantité")}</FormLabel>
                                    <Input
                                        type="number"
                                        min={1}
                                        variant="filled"
                                        focusBorderColor="blue.400"
                                        placeholder={t('Quantité')}
                                        defaultValue={getDataProduct_IdProduct?.quantity}
                                        onChange={e => setQuantityInput(e.target.value)}
                                    />
                                </FormControl>

                                <FormControl isRequired flex={1}>
                                    <FormLabel fontSize="sm" color="gray.500" fontWeight="600" display="flex" alignItems="center" gap={1}>
                                        <Text>{t("Prix d'achat")}</Text>
                                        <Badge colorScheme="green" rounded="sm" fontSize="2xs">{currentBusiness?.order_currency}</Badge>
                                    </FormLabel>
                                    <Input
                                        variant="filled"
                                        focusBorderColor="blue.400"
                                        placeholder={t("Prix d'achat")}
                                        value={purchase_PriceInput !== undefined ? purchase_PriceInput : getDataProduct_IdProduct?.price}
                                        onChange={e => {
                                            const val = handlePriceChange(e.target.value);
                                            if (val !== null) setPurchase_PriceInput(val);
                                        }}
                                    />
                                </FormControl>
                            </Flex>
                        </Stack>
                    </Box>
                </ModalBody>
            }

            <ModalFooter borderTop="1px solid" borderColor={modalHeaderBorderColor} pt={4} mt={2}>
                <Button variant="ghost" onClick={onCloseModalEditProduct} mr={3} rounded="full">
                    {t("Annuler")}
                </Button>
                <Button colorScheme='blue' rounded="full" px={6} shadow="md" isLoading={isUpdatingProduct} isDisabled={isUpdatingProduct} onClick={EditProductOrder}>
                    {t("Enregistrer les modifications")}
                </Button>
            </ModalFooter>
        </ModalContent>
            </Modal>


            {/* Alert to Delete Product */}

            <AlertDialog
                isOpen={deleteAlertOpen}
                leastDestructiveRef={deleteAlertRef}
                onClose={onCloseDeleteAlert}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t("Supprimer")}
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            {t("êtes-vous sûr ? Vous ne pourrez pas annuler cette action ultérieurement.")}
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={deleteAlertRef} onClick={onCloseDeleteAlert}>
                                {t("Annuler")}
                            </Button>
                            <Button onClick={DeleteProduct} isLoading={isDeletingProduct} isDisabled={isDeletingProduct} colorScheme='red' ml={3}>
                                {t("Supprimer")}
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>


            {/* Modal to edit client infox */}
            <Modal size="2xl" closeOnOverlayClick={ModalClientInfosRef} isOpen={isModalClientInfosOpen} onClose={onCloseModalClientInfos}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>{t("Modification des infos du client")}</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody pb={6}>

                        <Flex>
                            <Text color={bgCard}>{t("Informations client")}</Text>
                        </Flex>
                        <Flex gap={4} flexDirection={{ base: 'column', md: 'row' }}>
                            <FormControl isRequired>
                                <FormLabel>
                                    {t("Nom complet")}
                                </FormLabel>
                                <Input type='text' placeholder={t('Nom complet')} defaultValue={detailOrder?.full_name} onChange={e => setNomCompletClient(e.target.value)} />
                            </FormControl>
                            <FormControl>
                                <FormLabel>
                                    {t("Code (optionnel)")}
                                </FormLabel>
                                <Input type='text' placeholder={t('Laisser vide pour générer automatiquement')} value={codeCommande} onChange={e => setCodeCommande(e.target.value)} />
                            </FormControl>
                        </Flex>
                        <Flex gap={4} flexDirection={{ base: 'column', md: 'row' }}>
                            <FormControl>
                                <FormLabel>
                                    Email {t("(optionnel)")}
                                </FormLabel>
                                <Input type='email' placeholder={t("Email")} defaultValue={detailOrder?.email} onChange={e => setEmailClient(e.target.value)} />
                            </FormControl>
                            <FormControl isRequired>
                                <FormLabel>
                                    {t("Pays")}
                                </FormLabel>
                                <ReactSelect
                                    options={countryOptions}
                                    placeholder={t('Sélectionnez un pays')}
                                    onChange={(selected) => {
                                        setPaysClient(selected ? selected.label : '');
                                        setCodeCountryClient(selected ? selected.value : '');
                                    }}
                                    value={countryOptions.find(opt => opt.value === (codeCountryClient || detailOrder?.code_country)) || null}
                                    styles={{
                                        control: (baseStyles) => ({
                                            ...baseStyles,
                                            backgroundColor: 'transparent',
                                            borderColor: 'gray.200'
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            textAlign: 'left',
                                            backgroundColor: colorbg,
                                            cursor: "pointer"
                                        }),
                                        option: (provided, state) => ({
                                            backgroundColor: colorbg,
                                            ...provided,
                                            color: txtcolor,
                                            backgroundColor: state.isSelected ? colorbg : 'inherit',
                                            '&:hover': {
                                                backgroundColor: colorbghover,
                                            },
                                            cursor: "pointer"
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: txtcolor,
                                        }),
                                    }}
                                />
                            </FormControl>
                        </Flex>
                        <Flex gap={4} flexDirection={{ base: 'column', md: 'row' }}>
                            <FormControl isRequired>
                                <FormLabel>
                                    {t("Ville")}
                                </FormLabel>
                                <Input type='text' placeholder={t('Ville')} defaultValue={detailOrder?.ville} onChange={e => setVilleClient(e.target.value)} />
                            </FormControl>
                            <FormControl isRequired>
                                <FormLabel>
                                    {t("Adresse")}
                                </FormLabel>
                                <Input type='text' placeholder={t('Adresse')} defaultValue={detailOrder?.address} onChange={e => setAdresseClient(e.target.value)} />
                            </FormControl>
                        </Flex>
                        <Flex gap={4} flexDirection={{ base: 'column', md: 'row' }}>
                            <FormControl isRequired w={{ base: "100%", md: "50%" }}>
                                <FormLabel>
                                    {t("N°téléphone")}
                                </FormLabel>
                                <Flex
                                    alignItems="center"
                                    borderWidth="1px"
                                    borderColor="var(--chakra-colors-gray-200)"
                                    borderRadius="md"
                                    _focusWithin={{
                                        borderColor: "blue.500",
                                        boxShadow: "0 0 0 1px #3182ce"
                                    }}
                                    bg="transparent"
                                    transition="all 0.2s"
                                >
                                    <Box w='50%' borderRight="1px solid" borderColor="var(--chakra-colors-gray-200)">
                                        <ReactSelect
                                            options={countryOptions.map((c) => ({
                                                value: c.phoneCode,
                                                label: `${c.label.split(' ')[0]} ${c.phoneCode}`,
                                                fullLabel: `${c.label} (${c.phoneCode})`,
                                                searchString: `${c.label} ${c.phoneCode} ${c.value}`,
                                                countryValue: c.value,
                                                countryLabel: c.label
                                            }))}
                                            filterOption={(option, inputValue) => {
                                                return (option.data.searchString || '').toLowerCase().includes(inputValue.toLowerCase());
                                            }}
                                            value={{ value: phoneCode, label: phoneCode }}
                                            onChange={(selected) => {
                                                setPhoneCode(selected.value);
                                            }}
                                            formatOptionLabel={(data, { context }) => (
                                                context === 'menu' ? data.fullLabel : data.label
                                            )}
                                            styles={{
                                                control: (baseStyles) => ({
                                                    ...baseStyles,
                                                    backgroundColor: 'transparent',
                                                    borderColor: 'transparent',
                                                    boxShadow: 'none',
                                                    cursor: "pointer",
                                                    "&:hover": { borderColor: "transparent" }
                                                }),
                                                menu: (provided) => ({
                                                    ...provided,
                                                    backgroundColor: colorbg,
                                                    zIndex: 9999,
                                                    width: '280px'
                                                }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isSelected ? colorbg : 'inherit',
                                                    color: txtcolor,
                                                    '&:hover': {
                                                        backgroundColor: colorbghover,
                                                    },
                                                    cursor: "pointer"
                                                }),
                                                singleValue: (provided) => ({
                                                    ...provided,
                                                    color: txtcolor,
                                                    fontWeight: "600"
                                                }),
                                                dropdownIndicator: (provided) => ({
                                                    ...provided,
                                                    padding: "4px"
                                                })
                                            }}
                                        />
                                    </Box>
                                    <Input
                                        type='tel'
                                        pattern="^[0-9]*$"
                                        variant="unstyled"
                                        pl={3}
                                        py={2}
                                        height="100%"
                                        placeholder={t("N°téléphone")}
                                        value={phoneClient || ''}
                                        onChange={e => {
                                            const val = e.target.value.replace(/\s+/g, '');
                                            if (val === '' || /^[0-9]*$/.test(val)) {
                                                setPhoneClient(val);
                                            }
                                        }}
                                    />
                                </Flex>
                            </FormControl>
                        </Flex>

                    </ModalBody>

                    <ModalFooter>
                        <Button colorScheme='blue' size="sm" variant='outline' isLoading={isUpdatingClientInfos} isDisabled={isUpdatingClientInfos} mr={3} onClick={editClientInfos}>
                            {t("Modifier")}
                        </Button>
                        <Button onClick={onCloseModalClientInfos} size="sm" >{t("Annuler")}</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            {/* Alert to Update facture status */}

            <AlertDialog
                isOpen={isAlertOpenStatusFacture}
                leastDestructiveRef={cancelRefStatusFacture}
                onClose={onCloseAlertStatusFacture}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t('Statut de facture')}
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            <Text>
                                {t("Ici, vous pouvez modifier le statut de la facture.")}
                            </Text>

                            <Select
                                mt={3}
                                rounded='lg'
                                size={"sm"}
                                value={statusFacture}
                                onChange={e => setStatusFacture(e.target.value)}
                            >
                                <option value=''>{t('Statut de facture')}</option>
                                <option value='Non payé'>{t('Non payé')}</option>
                                <option value='Payé'>{t('Payé')}</option>
                            </Select>
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button
                                colorScheme='yellow'
                                size="sm"
                                variant='outline'
                                isLoading={isUpdatingStatusFacture}
                                isDisabled={!statusFacture || isUpdatingStatusFacture}
                                mr={3}
                                onClick={HandleChangeStatusFacture}
                            >
                                {t("Modifier")}
                            </Button>
                            <Button onClick={onCloseAlertStatusFacture} size="sm">{t("Annuler")}</Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>


        </Box>
    )
}

export default Details_GestConfirmation